import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireRouteAccess } from '@/lib/routeGuards';

/** Раздел «Assessments»: список шаблонов + вложенные роуты редактора (new / $id/edit). */
export const Route = createFileRoute('/_authed/admin/assessments')({
  beforeLoad: () => requireRouteAccess('/admin/assessments'),
  component: Outlet,
});
